

import templateComponent from '@/app-template/lib/components/ImageSlides.vue';

export default {
  components: { templateComponent },
};
